import { getRegisteredRum } from '@codametrix/client-registry';

const stubRUM = {
    startView: () => { },
    addAction: () => { },
    addError: () => { },
    setUser: () => { },
    setUserProperty: () => { },
    clearGlobalContext: () => { },
    setGlobalContextProperty: () => { },
    getGlobalContext: () => ({}),
};
function getRUM() {
    const fromRegistry = getRegisteredRum();
    if (fromRegistry) {
        return fromRegistry;
    }
    // Transitional fallback while bootstrap still assigns window.DD_RUM and
    // legacy call sites have not all migrated to getRUM()/registerRum.
    const rum = window.DD_RUM;
    return rum ?? stubRUM;
}

/**
 * Datadog RUM methods invoked from CodaMetrix app code (not bootstrap/init).
 * Keep in sync with repo usage of `getRUM()` / `window.DD_RUM`.
 */
const CMX_RUM_API_KEYS = [
    'startView',
    'addAction',
    'addError',
    'setUser',
    'setUserProperty',
    'clearGlobalContext',
    'setGlobalContextProperty',
    'getGlobalContext',
];

export { CMX_RUM_API_KEYS, getRUM };
//# sourceMappingURL=index.js.map
